import {Component, HostListener, inject, ViewEncapsulation} from "@angular/core";
import {Router} from "@angular/router";

const BUTTON_DISPLAY_POINT = 300;

@Component({
    selector: "otcx-layout-scroll-to-top",
    templateUrl: "./layout-scroll-to-top.component.html",
    styleUrls: ["./layout-scroll-to-top.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LayoutScrollToTopComponent {
    windowIsScrolled: boolean;
    private readonly router = inject(Router);

    @HostListener("window:scroll", [])
    onWindowScroll(): void {
        if (window.scrollY > BUTTON_DISPLAY_POINT) {
            this.windowIsScrolled = true;
        } else if (window.scrollY < 10) {
            this.windowIsScrolled = false;
        }
    }

    scrollToTop(): void {
        this.windowIsScrolled = false;

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });

        if (this.currentRouteContainsFragmentPath()) {
            this.clearFragmentFromRoute();
        }
    }

    private currentRouteContainsFragmentPath(): boolean {
        return this.router.url.includes("#");
    }

    private clearFragmentFromRoute(): void {
        this.router.navigateByUrl(this.getBaseUrlWithoutFragment(), {replaceUrl: true});
    }

    private getBaseUrlWithoutFragment(): string {
        return this.router.url.substring(0, this.router.url.indexOf("#"));
    }
}
